<template>
    <!-- 详情模块 -->
    <div class="cover-content form-wrapper">
        <div class="ft-box">
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>人员基本信息</span>
            </div>
            <div class="ft-form-wrapper">
                <div class="ft-form-item">
                    <div class="ft-th">姓名</div>
                    <div class="ft-td ft-bold">{{formData.workerName}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">籍贯</div>
                    <div class="ft-td">{{formData.nativePlace}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">身份证号</div>
                    <div class="ft-td">{{formData.idCardNumber}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">性别</div>
                    <div class="ft-td">{{formData.gender}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">年龄</div>
                    <div class="ft-td">{{formData.age}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">民族</div>
                    <div class="ft-td">{{formData.nation}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">出生日期</div>
                    <div class="ft-td">{{formData.birthday}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">住址</div>
                    <div class="ft-td">{{formData.address}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">联系电话</div>
                    <div class="ft-td">{{formData.cellPhone}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">政治面貌</div>
                    <div class="ft-td">{{formData.politicsType}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">文化程度</div>
                    <div class="ft-td">{{formData.cultureLevelType}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">紧急联系人</div>
                    <div class="ft-td">{{formData.urgentLinkMan}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">紧急联系电话</div>
                    <div class="ft-td">{{formData.urgentLinkManPhone}}</div>
                </div>
            </div>
        </div>
        <div class="ft-box">
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>从业经历</span>
            </div>
            <Table border size="large"
                   :columns="joinProjectColumns" :data="joinProjects" highlight-row>
                <template slot-scope="{ row, index }" slot="corpName">
                    <span class="ft-bold-blue link-span" @click="handleJump(row.corpId)">{{row.corpName}}</span>
                    <div>{{row.corpCode}}</div>
                </template>
                <template slot-scope="{ row, index }" slot="projectName">
                    <span class="ft-bold-blue">{{row.projectName}}</span>
                </template>
                <template slot-scope="{ row, index }" slot="workInDate">
                    <div>进：{{row.workInDate}}</div>
                    <div>退：{{row.workOutDate}}</div>
                </template>
            </Table>
        </div>
        <div class="ft-box">
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>教育培训经历</span>
            </div>
            <Table border size="large"
                   :columns="joinTrainColumns" :data="joinTrain" highlight-row>
                <template slot-scope="{ row, index }" slot="projectName">
                    <span class="ft-bold-blue link-span" @click="handleProject(row.projectId)">{{row.projectName}}</span>
                </template>
            </Table>
        </div>
        <div class="ft-box">
            <div class="ft-title aFlex">
            <Icon class="ft-title-mark" type="md-bookmark" />
            <span>考勤统计</span>
            </div>
      <div v-for="(item, index) in arrDate1" :key="index">
        <!-- <div>{{ item.projectName }}</div> -->
        <div style="font-size: 12px;font-weight: 600;">
          <span>{{ item.projectName }}</span>
          <span v-if="item.exitStatus && !item.exitDate">（已退场）</span>
          <span v-if="item.exitStatus && item.exitDate">（已于{{item.exitDate}}退场）</span>
        </div>
        <div class="attendanceLegend">
          <div class="attendanceLegend_left">
            <attendanceCalendar
             :workerId="workerId"
              :dataObj="item"
            ></attendanceCalendar>
          </div>
          <div class="attendanceLegend_right">
            <div class="attendanceLegend_rightbig">
              <attendanceTrend
                :workerId="workerId"
                :trendData="item"
              ></attendanceTrend>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import attendanceCalendar from '@/components/attendanceCalendar';
import attendanceTrend from '@/components/attendanceTrend';
export default {
  components: {
    attendanceCalendar,
    attendanceTrend,
  },
  data(){
    return {
      currDate1: '', //日历初始时间
      arrDate1: [], //日历初始项目考勤列表信息
      rprojectId: '', //日历初始获取项目id
      currDate: '', //日历时间变化时的时间点
      workerId: '',
      formData: {
        workerName: '',
        idCardNumber: '',
        gender: '',
        age: '',
        nation: '',
        birthday: '',
        address: '',
        cellPhone: '',
        politicsType: '',
        cultureLevelType: '',
        urgentLinkMan: '',
        urgentLinkManPhone: '',
      },
      joinProjectColumns:[
        {
          title: '企业名称',
          slot: 'corpName',
          align:'center',
          minWidth:100
        },
        {
          title: '参建项目',
          slot: 'projectName',
          align:'center'
        },
        {
          title: '工种（岗位）',
          key: 'workType',
          align:'center'
        },
        {
          title: '所属班组',
          key: 'teamName',
          align:'center'
        },
        {
          title: '进/退场时间',
          slot: 'workInDate',
          align:'center'
        },
        {
          title: '劳动合同',
          key: 'contractsNum',
          align:'center'
        }
      ],
      joinProjects:[],
      joinTrainColumns:[
        {
          title: '项目名称',
          slot: 'projectName',
          align:'center',
          minWidth:100
        },
        {
          title: '培训名称',
          key: 'trainingName',
          align:'center'
        },
        {
          title: '培训人',
          key: 'trainer',
          align:'center'
        },
        {
          title: '培训时间',
          key: 'trainingDate',
          align:'center'
        },
        {
          title: '培训时长（小时）',
          key: 'trainingDuration',
          align:'center'
        },
        {
          title: '培训类型',
          key: 'trainingType',
          align:'center'
        }
      ],
      joinTrain:[],
    };
  },
  computed: {},
  //进入路由之前 改变pname
  beforeRouteEnter(to,from,next){
    if(from.name == 'personnelList'){
      to.meta.pname = 'personnelList';
    }else {
      to.meta.pname = 'postList';
    }
    next();
  },
  created(){
    this.workerId= this.$route.query.workerId;
    this.getPageData();
    const date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month > 9 ? month : '0' + month;
    this.currDate1 = `${year}-${month}`;
    this.getCheckList1();
  },
  watch: {

  },
  methods: {
    /* 跳转页面 */
    handleJump(corpId){
      this.$router.push({
        name: 'unitDetail',
        query: {
          corpId:corpId
        }
      });
    },
    /* 跳转项目详情 */
    handleProject(projectId){
      this.$router.push({
        name: 'projectDetail',
        query: {
          projectId:projectId
        }
      });
    },
    /*取消返回*/
    handleCancel() {
      this.$router.go(-1);
    },
    /*获取页面信息*/
    getPageData(){
      this.axios({
        method: 'get',
        url:'/worker/sx/detail',
        params:{
          workerId:this.workerId,
        }
      }).then((response)=>{
        if(response.data.success){
          this.formData=response.data.data.workerInfo;
          this.joinProjects=response.data.data.joinProjects;
          this.joinTrain=response.data.data.joinTrain;
        }
      });
    },

    // 初始获取考勤列表数据
    getCheckList1() {
      this.loading = true;
      this.axios({
        method: 'get',
        url: '/project/workers/projectCalendar',
        params: {
          // workerId:'10344',
          workerId: this.workerId,
          // projectId:this.projectId,
          // corpId:this.corpId,
          date: this.currDate1,
        },
      })
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            console.log(response, '7777777777');
            this.arrDate1 = response.data.data;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  }
};
</script>
<style scoped>
.attendanceLegend {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.attendanceLegend_left {
  width: 49%;
  height: 435px;
  border: 2px solid #828282;
}
.attendanceLegend_right {
  width: 49%;
  height: 435px;
  background-color: #f0f2f5;
  display: flex;
  justify-content: center;
  align-items: center;
}
.attendanceLegend_rightbig {
  width: 95%;
  height: 95%;
  background-color: #dfebff;
  /* margin: auto;
    margin-top: 10px; */
}
</style>